"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SWAP_RATE_NAME_TO_PLATFORM_FEE_PERCENT = exports.SWAP_PLATFORM_FEE_PERCENT = exports.PAYPAL_WITHDRAWAL_PLATFORM_FEE_PERCENT = exports.EXTERNAL_WITHDRAWAL_PLATFORM_FEE_PERCENT = exports.EV_IO_TOURNAMENT_PLATFORM_FEE_PERCENT = exports.EV_IO_MATCH_PLATFORM_FEE_PERCENT = exports.PAPERGAMES_TOURNAMENT_PLATFORM_FEE_PERCENT = exports.COLYSEUS_TOURNAMENT_PLATFORM_FEE_PERCENT = exports.COLYSEUS_MATCH_PLATFORM_FEE_PERCENT = exports.LICHESS_TOURNAMENT_PLATFORM_FEE_PERCENT = exports.LICHESS_MATCH_PLATFORM_FEE_PERCENT = exports.DD_TOURNAMENT_PLATFORM_FEE_PERCENT = exports.DD_MATCH_PLATFORM_FEE_PERCENT = exports.LOL_TOURNAMENT_PLATFORM_FEE_PERCENT = exports.PLATFORM_FEE_CALCULATION_RATE = void 0;
const enums_1 = require("../enums");
exports.PLATFORM_FEE_CALCULATION_RATE = enums_1.ExchangeRateName.OKLP_USDT;
exports.LOL_TOURNAMENT_PLATFORM_FEE_PERCENT = 5;
exports.DD_MATCH_PLATFORM_FEE_PERCENT = 5;
exports.DD_TOURNAMENT_PLATFORM_FEE_PERCENT = 5;
exports.LICHESS_MATCH_PLATFORM_FEE_PERCENT = 5;
exports.LICHESS_TOURNAMENT_PLATFORM_FEE_PERCENT = 5;
exports.COLYSEUS_MATCH_PLATFORM_FEE_PERCENT = 5;
exports.COLYSEUS_TOURNAMENT_PLATFORM_FEE_PERCENT = 5;
exports.PAPERGAMES_TOURNAMENT_PLATFORM_FEE_PERCENT = 5;
exports.EV_IO_MATCH_PLATFORM_FEE_PERCENT = 5;
exports.EV_IO_TOURNAMENT_PLATFORM_FEE_PERCENT = 5;
exports.EXTERNAL_WITHDRAWAL_PLATFORM_FEE_PERCENT = 2;
exports.PAYPAL_WITHDRAWAL_PLATFORM_FEE_PERCENT = 4;
/**
 * @deprecated use `SWAP_RATE_NAME_TO_PLATFORM_FEE_PERCENT`, remove `SWAP_PLATFORM_FEE_PERCENT` after all dependent packages transition to `SWAP_RATE_NAME_TO_PLATFORM_FEE_PERCENT`.
 */
exports.SWAP_PLATFORM_FEE_PERCENT = 5;
exports.SWAP_RATE_NAME_TO_PLATFORM_FEE_PERCENT = {
    [enums_1.ExchangeRateName.OKLP_USDT]: 5,
    [enums_1.ExchangeRateName.USDT_OKLP]: 7.5,
    [enums_1.ExchangeRateName.OKLP_USD]: 100,
    [enums_1.ExchangeRateName.USDT_USDT]: 100, // The value is added for the ExchangeRateName enum consistency.
};
//# sourceMappingURL=platform-fee.js.map